export const AssignMailAPI = async (email, businessName, assigner) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-assign-mail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                businessName: businessName,
                assigner: assigner
            })
        });

        if (!response.ok) {
            console.error(`Failed to send assign mail, status: ${response.status}`);
            return null;
        }

        return await response.json();

    } catch (error) {
        console.error("Error sending assign mail:", error);
        return null;
    }
};
